import { CSSProperties } from 'styled-components';

export const googleMapStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  minHeight: '290rem',
  borderRadius: '8rem',
  maxHeight: '290rem',
};
